import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { AppSettings } from "src/app/app.settings";
import { WebCompany } from "src/app/models/RCCMobile.AppWebApi";
import { CompanyService, SharedService } from "src/app/services";
import { PasswordResetService } from "src/app/services/password-reset.service";
import { SessionDataService } from "src/app/services/session-data.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { AbstractControl } from "@angular/forms";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"]
})
export class ForgotPasswordComponent implements OnInit
{

  public webEmail: string;
  public title: string;
  private dataLogical: string;
  private custId: string;
  private company: WebCompany;
  private showCustIdInput: boolean = true;

  constructor(
    public appSettings: AppSettings,
    public router: Router,
    public dialog: MatDialog,
    public resetDialog: MatDialog,
    private companyService: CompanyService,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private passwordResetService: PasswordResetService,
    private sessionDataService: SessionDataService,
    private formValidationService: FormValidationService
  )
  { }

  public checkFormValidity(form: AbstractControl): void
  {
    
    if (this.formValidationService.checkFormValidity(form)) 
    {
      this.submitAction();
    }
  }
  
  ngOnInit(): void
  {
    this.dataLogical = this.sessionDataService.DataLogical;
    this.title = "Forgot Password";

    this.companyService.company.subscribe(c =>
    {
      this.company = c;

      this.route.queryParams
        .subscribe(params =>
        {
          if (params?.custId != undefined && params?.custId.length > 1)
          {
            this.custId = params.custId;
            this.showCustIdInput = false;
          }
          else
          {
            this.custId = this.sessionDataService.CustId;
          }
          this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;
          if (!this.showCustIdInput && this.custId.length > 1)
          {
            this.submitAction();
          }

        },
          () =>
          {
            this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;
          });
    });
  }

  private submitAction(): void
  {
    this.custId = this.custId.toUpperCase();

    if (SharedService.IsNullOrEmpty(this.dataLogical))
    {
      this.dataLogical = this.sessionDataService.DataLogical;

      this.passwordResetService.resetPasswordLogic(this.custId);
    }
    else
    {
      this.passwordResetService.resetPasswordLogic(this.custId);
    }
  }

}
